import React, {Component} from 'react';
import {Query} from 'react-apollo';
import {reach} from 'hoek';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

import CategoryWrapper from 'presentational/CategoryWrapper/CategoryWrapper';
import PageMeta from 'presentational/PageMeta/PageMeta';
import HeroHeader from 'presentational/HeroHeader/HeroHeader';
import Breadcrumbs from 'presentational/Breadcrumbs/Breadcrumbs';
import CardCarousel from 'presentational/CardCarousel/CardCarousel';
import FeaturedArticlesSection from 'presentational/FeaturedArticlesSection/FeaturedArticlesSection';
import FeaturedCallOutsSection from 'presentational/FeaturedCallOutsSection/FeaturedCallOutsSection';
import RelatedArticles from 'presentational/RelatedArticles/RelatedArticles';
import JsonSchema from './CategoryJsonSchema';
import {query} from './categoryQuery';

import {getBreadcrumbs} from 'utils/utils';
import {HomeRouteContext} from 'utils/context';
import withQuery from 'utils/withQuery';

const LoadedCategory = (props) => {
    const {
        systemData,
        allCategories,
        translations,
        response,
        homeRoute,
        isMobile,
    } = props;
    const {isTablet, hostname} = systemData;
    const isDevice = isMobile || systemData.isMobile || isTablet;
    const commonProps = {
        isDevice,
        translations,
    };
    const {
        data: {categoryCollection, subcategories},
    } = response;

    const category = reach(categoryCollection, 'items.0');
    const featuredArticles = reach(
        category,
        'featuredArticlesCollection.items',
    );
    const externalLinkCarousel = reach(category, 'externalLinkCarousel') || {};

    const canonical = `https://${hostname}${homeRoute}${category.path}`;
    const crumbs = getBreadcrumbs(
        allCategories,
        {name: translations.home, url: homeRoute},
        category,
    );

    return (
        <CategoryWrapper>
            <meta itemProp="mainEntityOfPage" content={canonical} />
            <PageMeta
                metaTitle={category.metaTitle}
                metaDescription={category.metaDescription}
                canonical={canonical}
                hreflangData={category.hreflang}
                heroFile={category.image}
                {...{systemData}}
            />
            <JsonSchema
                headline={category.headline}
                {...category}
                {...{systemData}}
                canonical={canonical}
                {...{featuredArticles, canonical}}
            />
            <HeroHeader
                title={category.headline}
                content={category.introduction}
                metaDescription={category.metaDescription}
                renderedCrumbs={
                    <Breadcrumbs crumbs={crumbs} hostname={hostname} />
                }
            />
            <CardCarousel
                title={translations.browseBySubcategory}
                cards={subcategories.items}
                {...commonProps}
            />
            <FeaturedArticlesSection
                title={category.featuredArticlesTitle}
                articles={featuredArticles}
                {...commonProps}
            />
            <FeaturedCallOutsSection
                callOuts={reach(category, 'callOutsCollection.items')}
                {...commonProps}
            />
            <CardCarousel
                title={externalLinkCarousel.title}
                cards={reach(
                    externalLinkCarousel,
                    'externalLinksCollection.items',
                )}
                {...commonProps}
            />
            <RelatedArticles
                title={translations.exploreArticles}
                category={category.sys.id}
                systemData={systemData}
                {...commonProps}
            />
        </CategoryWrapper>
    );
};

const CategoryWithLoading = withQuery(LoadedCategory);

export class CategoryContainer extends Component {
    static contextType = HomeRouteContext;
    render() {
        const {categoryId, preview} = this.props;
        const homeRoute = this.context;
        const variables = {categoryId, preview};

        return (
            <Query {...{query, variables}}>
                {(response) => {
                    return (
                        <CategoryWithLoading
                            {...{...this.props, response, homeRoute}}
                        />
                    );
                }}
            </Query>
        );
    }
}

export default determineIfMobile(CategoryContainer, 991);
